<template>
  <div class="aiPages" ref="aiPages">
    <div class="activity-header-container">
      <div
        class="activity-header"
        :style="{
          paddingTop: stateHeight,
          background: bgColor,
        }"
      >
        <van-nav-bar :border="false" class="navbar" placeholder>
          <template #left>
            <div class="left">
              <img
                class="icon-back"
                src="../assets/img/activity/ai/navbar_back.svg"
                @click="handleBack"
              />
            </div>
          </template>
          <template #title>
            <span>51Ai</span>
          </template>
          <template #right>
            <div class="right_class">
              <share-svg v-if="showShare" :componentConfig="shareConfig" />
            </div>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <div
      class="aiPages_wrap"
      :style="{
        paddingTop: parseInt(stateHeight) + 48 + 'px',
      }"
    >
      <!-- 开场白 -->
      <template v-if="!pageId">
        <div class="tip_wrap">
          <img
            class="ai_icon"
            src="../assets/img/activity/ai/ai_icon.png"
            alt=""
          />
          <span>求职路上有疑问？来问问51Ai 助手。</span>
        </div>
        <!-- 预设问题 -->
        <div class="default_questions">
          <div class="question_tip">试着问问...</div>
          <div
            class="question"
            v-for="(question, index) in questions"
            :key="index"
            @click="goSessionPage(question.interviewId)"
          >
            <span>{{ question.tit }}</span>
            <img src="../assets/img/activity/ai/target.png" alt="" />
          </div>
        </div>
      </template>
      <template>
        <div
          v-for="(item, key) in messageList"
          :key="key"
          :id="`chat${key}`"
          class="chat_item"
        >
          <!-- 3、用户的问题 -->
          <div v-if="item.prompt" class="user_questions">
            <div>
              {{ item.prompt }}
              <img
                class="dialog"
                src="../assets/img/activity/ai/blue.svg"
                alt=""
              />
            </div>
          </div>
          <!-- 4、AI的回答 -->
          <div v-if="!item.abortStream || item.text != ''" class="ai_answer">
            <div>
              <MarkRender
                :render-id="key"
                :text="item.text"
                :show-cursor="key == questionTime && streaming"
                :abort-stream="item.abortStream"
              />
              <span v-if="item.error" class="error">{{ item.error }}</span>
              <img
                class="dialog"
                src="../assets/img/activity/ai/white.svg"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="item.jobData && item.jobData.length > 0"
            class="job_item_wrap"
          >
            <div
              v-for="(job, jindex) in item.jobData"
              :key="jindex"
              class="job_item"
              @click="clickJobCard(job, jindex, item.jobData.length)"
            >
              <div class="job_item_top">
                <div class="job_header">
                  <span>{{ job.jobName }}</span>
                  <span v-if="job.provideSalaryString">{{
                    job.provideSalaryString
                  }}</span>
                </div>
                <div class="job_tag_wrap" v-if="job.jobTags?.length > 0">
                  <div class="tag_div">
                    <span
                      v-for="(tag, tkey) in job.jobTags"
                      :key="tkey"
                      :style="{ display: !tag ? 'none' : 'block' }"
                      >{{ tag }}</span
                    >
                  </div>
                </div>
                <div class="company_info">
                  <div v-if="job.companyName" class="company_info_comname">
                    <span>{{ job.companyName }}</span>
                  </div>
                  <span v-if="job.companyTypeString">{{
                    job.companyTypeString
                  }}</span>
                  <span v-if="job.companySizeString">{{
                    job.companySizeString
                  }}</span>
                </div>
                <div class="hr_info">
                  <div class="avatar">
                    <img
                      v-if="job.smallHrLogoUrl"
                      :src="job.smallHrLogoUrl"
                      alt=""
                    />
                    <img
                      v-else
                      :src="
                        require(`@/assets/img/activity/${
                          job.isFromXyx ? 'message_hr_fromxy' : 'message_hr_def'
                        }.png`)
                      "
                    />
                  </div>
                  <div class="onlineStatus" v-if="job.isOnline"></div>
                  <div class="info_txt">
                    <div>
                      <span class="name">{{
                        job.isFromXyx ? "应届生网申职位" : job.hrName || "HR"
                      }}</span>
                      <span class="hrpos" v-if="job.hrPosition">
                        · {{ job.hrPosition }}</span
                      >
                    </div>
                    <div
                      v-if="job.hrLabels && job.hrLabels[0]"
                      class="hrstatus"
                    >
                      {{ job.hrLabels[0] }}
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <div
                      class="chat"
                      v-if="job.isFromXyx && !platform.includes('App')"
                      @click.stop="toChat(job)"
                    >
                      去聊聊
                    </div>
                    <div
                      class="apply"
                      :class="{ sendState: job.isApply }"
                      @click.stop="toApply(job, key)"
                    >
                      {{ job.isApply ? "已投递" : "去投递" }}
                    </div>
                  </div>
                </div>
                <div class="hr_and_btn">
                  <div class="address">
                    {{
                      job.workAreaCode != "999999"
                        ? job.jobAreaString
                        : "远程办公"
                    }}
                    &nbsp;&nbsp;
                    {{ job.jobPositionString }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 5、回答相关引导 -->
          <div
            v-if="item.questions && item.questions.length > 0"
            class="guide_wrap"
          >
            <div
              class="guide_question"
              v-for="(q, qindex) in item.questions"
              :key="qindex"
              @click="selectQuestion(q)"
            >
              <span>{{ q }}</span>
              <img src="../assets/img/activity/ai/target.png" alt="" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="bottom_btn">
      <div class="inner">
        <input
          ref="inputQuestion"
          class="input_question"
          placeholder="输入想问的问题"
          v-model="customeQuestion"
          type="text"
          @keyup.enter="setInputQuestion()"
        />
        <img
          class="enter"
          src="../assets/img/activity/ai/enter.png"
          @click="setInputQuestion()"
        />
      </div>
    </div>
    <!--51组件-->
    <JbsApplyJob ref="applyJobRef" v-bind="applyJobProps" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import api from "@/utils/api";
import router from "@/router";
import { StreamGpt } from "@/utils/apiStream/stremFetch.js";
import { TypeWriter } from "@/utils/apiStream/typeWriter.js";
import MarkRender from "@/components/common/MarkRender.vue";
import ShareSvg from "@/components/ActivityHeader/components/ShareSvg.vue";
export default {
  name: "Ai",
  components: {
    MarkRender,
    ShareSvg,
  },
  props: {},
  data() {
    return {
      stateHeight: 0,
      bgColor: "",
      queryData: this.$route.query || {},
      /*****问答相关 */
      questions: {
        topnews: { tit: "我想了解近期的热点求职新闻", interviewId: "topnews" },
        jobrmd: { tit: "我想知道哪些工作适合我", interviewId: "jobrmd" },
        cor_comets: {
          tit: "我想了解某个公司的具体情况",
          interviewId: "cor_comets",
        },
        praiseme: { tit: "赶快使劲夸夸我", interviewId: "praiseme" },
        resopt: { tit: "帮我看看我的简历有哪些问题", interviewId: "resopt" },
      },
      customeQuestion: "", // 用户输入问题
      questionTime: "", // 问题id
      messageList: {}, // 当前会话也问题list
      streaming: false, // 问答正在输出中
      promptId: "", // 上一个问答id
      gpt: null, // gpt输出实例
      streamError: false, // 流失输出错误
      /*****分享相关 */
      showShare: false,
      shareConfig: {
        shareTitle: "51Ai",
        shareDescription: "求职路上有疑问？来问问51Ai 助手",
        shareIcon: decodeURIComponent(this.$route.query.shareIcon),
        backgroundColor: "#3c70ff",
      },
    };
  },
  computed: {
    ...mapState("applyJobStore", ["applyJobSignal", "applyOptions", "applied"]),
    ...mapGetters("resumeStore", ["resumeId"]),
    platform() {
      return this.$store.state.commonStore.platform;
    },
    applyJobProps() {
      let appType = null;
      if (this.$store.state.commonStore.platform.includes("51job")) {
        appType = "51job";
      }
      if (this.$store.state.commonStore.platform.includes("yjs")) {
        appType = "yjs";
      }
      return {
        cupid: api.cupid,
        young: api.young,
        vapi: api.vapi,
        appType: appType,
      };
    },
    noResume() {
      // return true;
      return !this.resumeId;
    },
    pageId() {
      return this.$route.params.interviewId;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  watch: {
    applyJobSignal() {
      if (this.isApp) {
        // app 内
        this.$refs.applyJobRef.applyJob(this.applyOptions);
      } else {
        if (this.noResume) {
          this.$toast.clear();
          this.$toast.fail("投递失败，请先完善简历");
          return;
        }
        this.$refs.applyJobRef.applyJobH5({
          ...this.applyOptions,
          resumeId: this.resumeId,
          onFail: this.onApplyH5Fail,
        });
      }
    },
    pageId(nv) {
      this.messageList = {};
      this.promptId = "";
      this.streaming = false;
      this.customeQuestion = "";
      this.abortStreamEvent();
      this.$refs.inputQuestion.blur();

      if (nv) {
        this.handleFetchGptStream();
      }
    },
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll);
      this.init();
      if (this.pageId) {
        this.handleFetchGptStream();
      }
    });
  },
  methods: {
    ...mapActions("applyJobStore", ["applyJob"]),
    ...mapActions("resumeStore", ["loadBestResume"]),
    init() {
      if (this.isLogin && this.noResume) {
        this.loadBestResume(); // 获取最佳简历
      }
      this.showShare =
        this.platform === "51jobApp" || this.platform === "yjsApp";
      if (this.platform === "51jobWX" || this.platform === "yjsWX") {
        this.$base.wxSharePost({
          shareDescription: this.shareConfig.shareDescription,
          shareIcon: this.shareConfig.shareIcon,
          shareTitle: this.shareConfig.shareTitle,
        });
      }
    },
    goSessionPage(interviewId) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_presetquestion",
        bcopExrinfo: {
          pagecode: this.queryData.pagecode || "",
          topicid: interviewId,
        },
      });
      const q = this.$route.query;
      this.$router.push({
        name: "AiSub",
        params: {
          interviewId,
        },
        query: {
          ...q,
        },
      });
    },
    clickJobCard(item, index, length) {
      if (this.$base.checkLoginStatus(true)) {
        this.$base.toJobDetail(item, index, length);
      }
    },
    toChat(item) {
      if (this.$base.checkLoginStatus(true)) {
        let property = {
          pageCode: this.queryData.pagecode || "",
        };
        this.$base.goChatNew(item, this.$store.state.commonStore, property);
      }
    },
    toApply(item, qkey) {
      if (this.$base.checkLoginStatus(true) && !item.isApply) {
        if (item.isFromXyx) {
          //网申
          this.$base.toJobDetail(item);
        } else {
          // 单投
          const property = (item?.property && JSON.parse(item.property)) || {};
          property.pageCode =
            this.queryData.pagecode || property.pageCode || "";
          property.shortPageCode = property.pageCode;

          const params = {
            item: { ...item, jobId: String(item.jobId) },
            property: {
              ...property,
              fromModule: "列表单投",
            },
            isShowToast: "1",
            onSuccess: () => {
              this.changeItemIsApply(item, qkey);
            },
          };
          this.applyJob(params);
        }
      }
    },
    // 投递成功后按钮展示已投递
    changeItemIsApply(item, qkey) {
      this.messageList[qkey].jobData.find(
        (job) => job.jobId === item.jobId
      ).isApply = true;
      this.$forceUpdate();
    },
    buttonTypeChat(item) {
      let platform = this.platform;
      let isApp = this.$store.getters.isApp;

      if (isApp) {
        if (platform == "51jobApp") {
          // 51
          return item.buttonType == 1;
        } else if (platform == "yjsApp") {
          // yjs
          return item.isApply;
        }
      }
      return false;
    },
    selectQuestion(text) {
      this.abortStreamEvent();
      this.customeQuestion = text;
      this.handleFetchGptStream(true);
    },
    setInputQuestion() {
      this.$refs.inputQuestion.blur();
      this.abortStreamEvent();
      this.handleFetchGptStream(true);
    },
    abortStreamEvent() {
      if (this.gpt) {
        if (this.messageList[this.questionTime]) {
          this.messageList[this.questionTime].abortStream = true;
        }
        this.gpt.onAbort();
      }
    },
    handleFetchGptStream(isCustome = false) {
      const prompt =
        this.pageId && !isCustome
          ? this.questions[this.pageId].tit
          : this.customeQuestion;
      const interviewId = this.pageId || "customize";
      const params = {
        prompt: prompt,
        fup: this.promptId,
        aid: this.$store.state.commonStore.accountId,
        interviewId: interviewId,
        pagecode: this.queryData.pagecode || "",
      };
      this.$api.activity.aiAssistantToken(params).then((res) => {
        if (res.code == "0") {
          params.token = res.data;
          this.useRecommend(params);
          this.customeQuestion = "";
        }
      });
    },
    useRecommend(params) {
      this.gpt = null;
      const _this = this;

      const typewriter = new TypeWriter((str) => {
        if (
          this.messageList[this.questionTime] &&
          !_this.messageList[_this.questionTime].abortStream
        ) {
          _this.messageList[_this.questionTime].text += str || "";
          _this.$forceUpdate();
          _this.scrollToBottom();
        }
      });

      this.gpt = new StreamGpt({
        onStart: (prompt) => {
          _this.streaming = true;
          const date = new Date();
          _this.questionTime = date.getTime();
          _this.messageList[_this.questionTime] = {
            key: _this.questionTime,
            prompt,
            text: "",
          };
          _this.$forceUpdate();
          _this.scrollToBottom();
        },
        onPatch: (text) => {
          typewriter.add(text);
        },
        onCreated: () => {
          typewriter.start();
        },
        onDone: (data) => {
          typewriter.done();
          _this.promptId = data.promptId;
          const jobIds = !data.jobInfoList ? [] : data.jobInfoList.slice(0, 4);
          const questions = data.questionList;

          if (jobIds.length > 0) {
            _this.loadJobQuestions(jobIds, questions);
          } else {
            _this.messageList[_this.questionTime].questions = questions;
          }
          _this.streaming = false;
        },
        onError: () => {
          typewriter.done();
          _this.streaming = false;
          _this.messageList[_this.questionTime].error =
            "【服务繁忙，请稍后重试】";
          _this.streamError = true;
        },
        onAbort: () => {
          typewriter.done();
          _this.gpt.controller.abort();
          _this.streaming = false;
        },
      });

      this.gpt.stream(params);
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 10) {
        this.bgColor = "#4B7ADE";
      } else {
        this.bgColor = "";
      }
    },
    handleBack() {
      router.go(-1);
    },
    loadJobQuestions(jobs, questions) {
      const params = {
        componentId: "",
        jobIdList: jobs,
      };
      this.$api.activity.getJobInfo(params).then((res) => {
        if (res.code == "0") {
          this.messageList[this.questionTime].jobData = res.data;
          this.messageList[this.questionTime].questions = questions;
          this.$forceUpdate();
          this.scrollToBottom();
        }
      });
    },
    scrollToBottom() {
      const docHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      if (this.$refs.aiPages.clientHeight > docHeight) {
        this.$nextTick(() => {
          window.scrollTo({
            top: this.$refs.aiPages.clientHeight,
            behavior: "smooth",
          });
        });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less">
#app {
  height: 100vh;
}
</style>
<style scoped lang="less">
.aiPages {
  display: block;
  position: relative;
  // max-width: 100%;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #beecdf;
  .aiPages_wrap {
    padding-bottom: 130px;
    padding-top: 48px;
    min-height: 100vh;
    padding: 48px 12px 130px;
    z-index: 2;
    position: relative;
    .tip_wrap {
      background: rgba(255, 255, 255, 0.85);
      border-radius: 12px;
      // width: 351px;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 5px 8px;
      box-sizing: border-box;
      margin: 12px 0 10px;
      color: #0430a7;
      font-size: 16px;
      font-weight: 500;
      .ai_icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
    }
    .default_questions {
      // width: 351px;
      border-radius: 20px;
      padding: 8px 16px 16px;
      margin-bottom: 36px;
      background: linear-gradient(
        180deg,
        rgba(224, 253, 252, 0.6) 0%,
        rgba(219, 238, 255, 0.6) 100%
      );
      .question_tip {
        color: #222222;
        font-weight: 600;
        font-size: 12px;
        margin-bottom: 8px;
        margin-left: 8px;
      }
      .question {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 11px 12px;
        background: #ffffff;
        border-radius: 12px;
        box-sizing: border-box;
        border: 0.5px solid #93bdf4;
        color: #222222;
        font-weight: normal;
        line-height: 1;
        justify-content: space-between;
        margin-top: 6px;

        span {
          font-size: 14px;
        }
      }
    }
    .user_questions {
      margin-bottom: 16px;
      display: flex; /* 启用Flexbox布局 */
      justify-content: flex-end; /* 子元素靠右对齐 */
      div {
        position: relative;
        margin-right: 8px;
        margin-left: 48px;
        border-radius: 12px;
        padding: 8px 14px;
        background: #0a6cff;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        display: inline-block;
        .dialog {
          position: absolute;
          right: -8px;
          width: 23px;
          height: 17px;
          top: 4px;
        }
      }
    }
    .ai_answer {
      margin-bottom: 16px;
      & > div {
        position: relative;
        margin-right: 48px;
        margin-left: 8px;
        border-radius: 12px;
        padding: 8px 14px;
        background: #ffffff;
        font-size: 14px;
        font-weight: 500;
        color: #222222;
        display: inline-block;

        .dialog {
          position: absolute;
          left: -8px;
          width: 23px;
          height: 17px;
          top: 4px;
        }
      }
      .error {
        color: red;
      }
    }
    .job_item_wrap {
      border-radius: 20px;
      padding: 10px 16px 16px;
      background: linear-gradient(
        180deg,
        rgba(224, 253, 252, 0.6) 0%,
        rgba(219, 238, 255, 0.6) 100%
      );
      margin-bottom: 32px;
    }
    .job_item {
      margin-top: 6px;
      background: #ffffff;
      border-radius: 8px;
      // padding: 16px;
      // padding-top: 0;
      .job_item_top {
        padding: 13px 12px;
      }

      .job_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        color: #ff6c0e;
        line-height: 15px;
        & > span {
          &:first-child {
            color: #222222;
            line-height: 19px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 17px;
          }
          &:nth-child(2) {
            margin-left: 26px;
            font-size: 15px;
          }
        }
      }
      .job_tag_wrap {
        margin-top: 8px;
        display: flex;
        flex-flow: row;
        overflow: hidden;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        .tag_div {
          display: flex;
          flex-flow: row;
          align-items: center;
          max-width: 260px;
          flex-grow: 0;
          overflow: hidden;
          height: 24px;
          flex-wrap: wrap;
          & > span {
            font-size: 12px;
            background: #f4f8fb;
            border-radius: 4px;
            margin-right: 5px;
            margin-bottom: 2px;
            padding: 0 6px;
            color: #4c4f54;
            flex-shrink: 0;
            padding: 4px 8px;
            min-height: 24px;
          }
        }
      }
      .company_info {
        // font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #4c4f54;
        line-height: 14px;
        margin-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        width: 100%;
        .company_info_comname {
          overflow: hidden;
          display: inline;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            display: block;
          }
        }
        & > span {
          margin: 0 4px;
          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .hr_info {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 10px;
        border-top: 0.5px solid #edeff2;
        padding-top: 7.5px;
        .avatar {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          overflow: hidden;
          background-color: #fff;
          display: flex;
          align-items: center;
          & > img {
            width: 100%;
            height: auto;
          }
        }
        .onlineStatus {
          border: 1px solid #ffffff;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #2dd685;
          position: absolute;
          bottom: 0;
          left: 15px;
        }
        .info_txt {
          margin-left: 6px;
          flex: 1;
        }
        .name {
          font-size: 12px;
          color: #4c4f54;
        }
        .hrpos {
          font-size: 12px;
          color: #4c4f54;
        }
        .hrstatus {
          font-size: 11px;
          font-weight: normal;
          line-height: 15px;
          color: #afb3ba;
          margin-top: 2px;
        }
        .btn_wrap {
          display: flex;
          align-items: center;
          justify-content: right;
          div {
            padding: 7px 10px;
            border-radius: 15px;
            box-sizing: border-box;
            font-size: 12px;
            font-weight: 500;
          }
          .chat {
            margin-right: 6px;
            color: #3c70ff;
            background: #d8e2ff;
            border: 0.5px solid #d8e2ff;
          }
          .apply {
            color: #ffffff;
            background: #3c70ff;

            &.sendState {
              background: #dcdcdc;
            }
          }
        }
      }
      .hr_and_btn {
        display: flex;
        justify-content: space-between;
        align-items: end;
        .address {
          // font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #afb3ba;
          // line-height: 14px;
          margin-top: 9px;
        }
      }
    }
    .guide_wrap {
      margin-bottom: 36px;
      padding: 0 16px;
    }
    .guide_question {
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.7);
      box-sizing: border-box;
      border: 1px solid #93bdf4;
      padding: 0 12px;
      padding-right: 44px;
      margin-bottom: 6px;
      height: 36px;
      line-height: 36px;
      display: block;
      position: relative;
      width: fit-content;
      max-width: 100%;

      span {
        display: block;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
        height: 36px;
        line-height: 36px;
        color: rgba(34, 34, 34, 0.8);
        font-size: 12px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        display: block;
        position: absolute;
        width: 20px;
        height: auto;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
      }
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding-bottom: 21px;
    background: #c6d9dc;
    z-index: 2;

    .inner {
      position: relative;
      padding: 12px 16px;
    }
    .input_question {
      border-radius: 10px;
      background: #ffffff;
      border: none;
      width: 100%;
      height: 44px;
      line-height: 44px;
      position: relative;
      box-sizing: border-box;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0px;
      color: #222222;
      padding: 13px 62px 14px 11px;
    }
    .enter {
      height: 30px;
      width: 30px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 24px;
    }
  }
  .activity-header-container {
    color: #ffffff;
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
      .icon-subscribe {
        display: inline-block;
        width: 26px;
        height: 26px;
      }
    }
  }
  .loading {
    text-align: center;
    font-weight: 400;
    font-size: 13px;
    color: #000000;
    line-height: 18px;
    margin: 15px 0 25px 0;
  }
  /deep/ .van-list__loading {
    margin: 11px 0 27px 0;
    .van-loading--circular {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-loading__circular {
      display: none;
    }
    .van-loading__spinner--circular {
      height: 16px !important;
      display: block;
      width: 14px !important;
    }
    .van-loading__spinner--circular::after {
      content: "";
      background-image: url("~@/assets/img/activity/loading@2x.png");
      background-size: cover;
      height: 16px;
      display: block;
      width: 14px;
      background-repeat: no-repeat;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .van-loading__text {
      font-weight: 400;
      font-size: 13px;
      color: #4e4e4e;
      margin-left: 6px;
    }
  }
  /deep/ .van-list__error-text,
  /deep/ .van-list__finished-text,
  /deep/ .van-list__loading {
    color: #4e4e4e;
    text-align: center;
    margin: 11px 0 0px 0;
  }
}
.aiPages::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 442px;
  z-index: 1;
  background-image: url("../assets/img/activity/ai/bg.png");
}
</style>
